<template>
  <div class="skeleton-avatar" :style="{ width: size, height: size }">
  </div>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: '50px',
    },
  },
};
</script>
<style>
  .skeleton-avatar{
    background-color: #dedede;
  }
  .skeleton-avatar {
    border-radius: 50% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/skeletons/Avatar.vue